const messages: Record<string, string> = {
  'app.welcome': 'Welcome',
  'app.chat.placeholder': 'Type a message...',
  'app.chat.send': 'Send',
  'app.chat.attach': 'Attach file',
  'app.connection.status.connected': 'Connected',
  'app.connection.status.disconnected': 'Disconnected',

  // Common
  'common.warning': 'Warning',
  'common.missingData': 'Missing Data',
  'common.confirmation': 'Confirmation',
  'common.actions': 'Actions',
  'common.loading': 'Loading...',
  'common.confirm': 'Confirm',
  'common.cancel': 'Cancel',
  'common.continue': 'Continue',
  'common.custom': 'Custom',
  'cycle.template.banner':
    "Templates are reusable. They don't have a start date — that's chosen when you assign the template to a client.",
  'common.showing': 'Showing',
  'common.of': 'of',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.save': 'Save',
  'common.saveAll': 'Save All',
  'common.copy': 'Copy',
  'common.template': 'Template',
  'common.useAsTemplate': 'Use as Template',
  'common.close': 'Close',
  'common.search': 'Search',
  'common.filter': 'Filter',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.noData': 'No data available',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.confirmation.saveChanges': 'Are you sure you want to save these changes?',
  'common.selectDate': 'Select Date',
  'common.noResults': 'No results found.',
  'common.status': 'Status',
  'common.select': 'Select',
  'common.update': 'Update',
  'common.errorSavingChanges': 'Error saving changes',
  'common.errorVerifyingChanges': 'Error verifying changes',
  'common.error': 'Error',
  'common.success': 'Success',
  'common.errorNameRequired': 'The plan name is required',
  'common.assign': 'Assign',
  'common.unassign': 'Unassign',
  'common.create': 'Create',
  'common.add': 'Add',
  'common.createNew': 'Create New',
  'common.completedOn': 'Completed on',
  'common.sessionTime': 'Session time',
  'common.feedback': 'Feedback',
  'common.mood': 'Mood',
  'common.energyLevel': 'Energy level',
  'common.perceivedDifficulty': 'Perceived difficulty',
  'common.extraNotes': 'Extra notes',
  'common.group': 'Group',
  'common.days': 'Days',
  'common.age': 'Age',
  'common.years': 'years',
  'common.months': 'months',
  'common.weeks': 'weeks',
  'common.startDate': 'Start Date',
  'common.endDate': 'End Date',
  'common.comingSoon': 'Coming Soon',

  'common.day': 'Day',
  'common.week': 'Week',
  'common.cycle': 'Cycle',
  'common.selectCycle': 'Select cycle',
  'common.all': 'All',
  'common.location': 'Location',
  'common.contactMethod': 'Contact Method',
  'common.notes': 'Notes',
  'common.selectContactMethod': 'Select Contact Method',
  'common.trainingType': 'Training Type',
  'common.selectTrainingType': 'Select Training Type',

  'home.success.checkEmail': 'Check your email to continue!',
  // Mensajes de confirmacion
  'assignPlan.confirmation.message': 'Are you sure you want to assign this plan?',
  'assignPlan.success': 'Plan assigned successfully',
  'assignSubscription.confirmation.message': 'Are you sure you want to generate a subscription for this client?',
  'assignSubscription.autoCalculated': 'auto-calculated',
  'assignSubscription.noPlansYet':
    "You don't have any services yet. Create your first service to assign this subscription.",
  'assignSubscription.error.selectPlan': 'Please select a coach plan',
  'assignSubscription.error.startDateRequired': 'Please select a start date',
  'student.confirm.createPlanFirst.header': 'Create a plan first',
  'student.confirm.createPlanFirst.message':
    "You don't have any plans yet. Do you want to create one now to assign this subscription?",
  'assignSubscription.createFirstPlan': 'Create my first service',
  'assignSubscription.createInlinePlan': 'Create new service',
  'coach.plan.error.nameRequired': 'Plan name is required',
  'coach.plan.error.priceRequired': 'Plan price is required',
  'coach.plan.success.created': 'Plan created successfully',
  'coach.plan.success.updated': 'Plan updated successfully',
  'coach.plan.success.deleted': 'Plan deleted successfully',
  'coach.plan.error.requiredFields': 'Complete the required fields',
  'coach.plan.error.save': 'Could not save the plan',
  'coach.plan.error.delete': 'Could not delete the plan',
  'createCycle.confirmation.message': 'Are you sure you want to create this plan?',
  'deletePlan.confirmation.message': 'Are you sure you want to delete this workout plan?',
  'deleteStudent.confirmation.message': 'Are you sure you want to delete this student?',
  'registerPayment.confirmation.message':
    "Are you sure you want to register this payment and update the client's subscription?",
  'deleteExercise.confirmation.message': 'Are you sure you want to delete this exercise?',
  'createExercise.confirmation.message': 'Are you sure you want to create this exercise?',
  'updateExercise.confirmation.message': 'Are you sure you want to update this exercise?',
  'coach.plan.confirm.create': 'Are you sure you want to create this plan?',
  'coach.plan.confirm.update': 'Are you sure you want to update this plan?',
  'coach.plan.confirm.delete': 'Are you sure you want to delete this plan?',
  'coach.workout.confirm.delete': 'Are you sure you want to delete this workout?',

  'coach.exercise.confirm.upload': 'Are you sure you want to upload {rowsCount} exercises?',

  'coach.exercise.success.created': 'Exercise created successfully',
  'coach.exercise.success.updated': 'Exercise updated successfully',
  'coach.exercise.success.deleted': 'Exercise deleted successfully',
  'coach.exercise.selectType': 'Select Exercise Type',

  'rpe.setAsDefault': 'Use this method by default',
  'coach.rpe.confirm.delete': 'Are you sure you want to delete this measurement method?',
  'coach.rpe.success.created': 'Measurement method created successfully',
  'coach.rpe.success.updated': 'Measurement method updated successfully',
  'coach.rpe.success.deleted': 'Measurement method deleted successfully',
  'coach.rpe.error.deleted': 'Could not delete the measurement method',
  'coach.rpe.success.defaultChanged': 'Default method updated successfully',
  'coach.rpe.confirm.assign': 'Are you sure you want to assign {rpe} to the selected {type}?',
  'coach.plan.confirm.clear': 'Are you sure you want to clear the entire workout plan?',
  'coach.subscription.confirm.delete': "Are you sure you want to delete this client's subscription?",
  'coach.subscription.success.deleted': 'Subscription deleted successfully',
  // Messages for NewCoachHome
  'welcome.back': 'Welcome back, {name}!',
  'stats.totalClients': 'Total Clients',
  'stats.activePlans': 'Active Plans',
  'stats.upcomingSessions': 'Upcoming Sessions',
  'clients.title': 'Clients',
  'clients.search': 'Search clients...',
  'clients.noClientsFound': 'No clients found.',
  'clients.completed': 'Completed',
  'clients.pending': 'Pending',
  'clients.expired': 'Expired',
  'trainingPlans.title': 'Training Plans',
  'trainingPlans.newPlan': 'New Plan',
  'trainingPlans.editPlan': 'Edit Plan',
  'recentActivity.title': 'Recent Activity',
  'messages.title': 'Recent Messages',
  'messages.openChat': 'Open Chat',
  'workoutProgress.title': 'Workout Progress',
  'subscription.title': 'Subscription Status',
  'subscription.currentPlan': 'Current Plan: Premium',
  'subscription.clientsManaged': 'Clients Managed: {current}/{total}',
  'subscription.upgradePlan': 'Upgrade Plan',
  'upcomingSessions.title': 'Upcoming Sessions',
  'upcomingSessions.noSession': 'No upcoming session',
  // NewClientDashboard
  'clientDashboard.title': 'Client Dashboard',
  'clientDashboard.tabs.calendar': 'Workout Calendar',
  'clientDashboard.tabs.details': 'Workout Details',
  'clientDashboard.tabs.excelView': 'Excel View',

  'clientDashboard.buttons.assign': 'Assign Workouts',
  'clientDashboard.buttons.unassign': 'Delete sessions/cycles',
  'clientDashboard.buttons.createCycle': 'Create Training Cycle',
  'clientDashboard.buttons.assignCycleTemplate': 'Assign Cycle Template',
  'clientDashboard.addSession': 'Add session',
  'clientDashboard.success': 'Success',
  'clientDashboard.success.cycleAssigned': 'Training cycle successfully assigned.',
  'clientDashboard.error.selectCycleAndDates': 'Please select a training cycle and start/end dates.',
  'clientDashboard.assignCycleTemplate.dialog.header': 'Assign Training Cycle Template',
  'clientDashboard.assignCycleTemplate.selectCycle': 'Select Training Cycle',
  'clientDashboard.assignCycleTemplate.selectCyclePlaceholder': 'Select a training cycle',

  'clientDashboard.workout.completedOn': 'Completed on',
  'clientDashboard.workout.sessionTime': 'Session time',
  'clientDashboard.workout.feedback': 'Feedback',
  'clientDashboard.workout.mood': 'Mood',
  'clientDashboard.workout.energy': 'Energy level',
  'clientDashboard.workout.difficulty': 'Difficulty',
  'clientDashboard.workout.notes': 'Extra notes',

  'clientDashboard.dropdown.selectWorkout': 'Select a Workout',
  'clientDashboard.dropdown.selectExercise': 'Select an Exercise',

  'clientDashboard.table.workoutName': 'Workout Name',
  'clientDashboard.table.details': 'Details',
  'clientDashboard.table.set': 'Set',
  'clientDashboard.table.type': 'Type',
  'clientDashboard.table.expected': 'Expected',
  'clientDashboard.table.completed': 'Completed',
  // NewClientProfile
  'profile.title': 'Client Profile',
  'profile.title.mine': 'My Profile',
  'profile.today.title': 'Today',
  'profile.today.training': "Today's workout",
  'profile.today.startTraining': 'Start training',
  'profile.today.completed.title': 'Congrats! You finished your training for today',
  'profile.today.viewDetails': 'View details',
  'profile.today.restDay': 'Today is a rest day',
  'profile.today.restSubtitle': 'Take the chance to recover',
  'profile.streak.title': 'Streak',
  'profile.streak.days': 'days in a row',
  'profile.streak.startNow': 'Start your streak today!',
  'profile.subscription.daysLeft': '{days, plural, one {# day left} other {# days left}}',
  'profile.subscription.expired': 'Expired',
  'profile.subscription.none': 'You have no active plan',
  'profile.coach.title': 'Your Coach',
  'profile.coach.contact': 'Contact',
  'profile.recentHistory': 'Recent History',
  'profile.recentHistory.empty': 'No workouts recorded yet',
  'profile.toast.noData': 'No profile data available',
  'profile.toast.updated': 'Personal information updated successfully',
  'profile.validation.fitnessGoal': 'Fitness goal cannot be empty',
  'profile.validation.activityLevel': 'Activity level cannot be empty',
  'gender.male': 'Male',
  'gender.female': 'Female',
  'gender.other': 'Other',
  'profile.personalInfo': 'Personal Information',
  'profile.name': 'Name',
  'profile.email': 'Email',
  'profile.birthdate': 'Birthdate',
  'profile.gender': 'Gender',
  'profile.phone': 'Phone',
  'profile.edit': 'Edit',

  'profile.subscription': 'Current Subscription',
  'profile.subscription.planName': 'Plan Name',
  'profile.subscription.startDate': 'Start Date',
  'profile.subscription.endDate': 'End Date',
  'profile.subscription.status': 'Status',
  'profile.subscription.frequency': 'Billing',
  'profile.subscription.frequency.monthly': 'Monthly',
  'profile.subscription.frequency.weekly': 'Weekly',
  'profile.subscription.frequency.per_session': 'Per session',
  'profile.subscription.sessionsUsed': 'Sessions completed',

  'profile.tabs.workoutHistory': 'Workout History',
  'profile.tabs.progress': 'Progress',
  'profile.tabs.activities': 'User Historical Activities',

  'profile.table.planName': 'Plan Name',
  'profile.table.details': 'Details',
  'profile.table.trainingDate': 'Training Date',
  'profile.table.dayTrained': 'Day Trained',
  'profile.table.status': 'Status',
  'profile.table.date': 'Date',
  'profile.table.action': 'Action',
  'profile.table.week': 'Week {number}',
  'profile.table.day': 'Day {number}',

  'profile.dialog.edit': 'Edit Personal Information',
  'profile.dialog.fitnessGoal': 'Fitness Goal',
  'profile.dialog.activityLevel': 'Activity Level',
  'profile.dialog.cancel': 'Cancel',
  'profile.dialog.save': 'Save',

  'profile.goals.weightLoss': 'Weight loss',
  'profile.goals.muscleGain': 'Muscle gain',
  'profile.goals.mobility': 'Gain mobility',
  'profile.goals.maintenance': 'Maintenance',
  'profile.goals.flexibility': 'Flexibility',

  'profile.activity.sedentary': 'Sedentary',
  'profile.activity.moderate': 'Moderately active',
  'profile.activity.active': 'Very active',

  // NewCoachProfile
  'coach.welcome': 'Welcome, {name}!',
  'coach.email': 'Email',
  'coach.experience': 'Experience',
  'coach.trainingType': 'Training Type',
  'coach.gymLocation': 'Gym Location',
  'coach.biography': 'Biography',

  'coach.workouts.title': 'Workouts',
  'coach.workout.details': 'Workout Details',
  'coach.workout.success.deleted.message': 'Workout deleted successfully!',
  'coach.workout.success.assigned.message': 'Workout assigned successfully!',
  'coach.workout.success.unassigned.message': 'Workout unassigned successfully!',
  'coach.workout.error.selectWorkoutAndDay': 'Please select a workout and a day of the week for the last assignment.',
  'coach.workout.error.selectAtLeastOneWorkout': 'Please select at least one workout.',
  'coach.workoutsPerWeek': 'workouts per week',
  'coach.exercise.upload.success': 'Exercises uploaded',
  'coach.exercise.upload.duplicated': 'Duplicated Exercises',
  'coach.rpe.assign.type': 'Select Assignment Type',
  'coach.rpe.assign.rpe': 'Select RPE',

  // NewCreatePlan
  'coach.createPlan.title': 'Create Training Plan',
  'coach.createPlan.subtitle': 'Create a personalized training plan for your clients',
  'coach.createPlan.description': 'Use this page to create a personalized training plan for your clients',
  'coach.createPlan.name': 'Plan Name',
  'coach.createPlan.duration': 'Duration (weeks)',
  'coach.createPlan.workoutsPerWeek': 'Workouts per week',
  'coach.createPlan.startDate': 'Start Date',
  'coach.createPlan.endDate': 'End Date',
  'coach.createPlan.workouts': 'Workouts',
  'coach.createPlan.addWorkout': 'Add Workout',
  'coach.createPlan.save': 'Save Plan',
  'coach.createPlan.cancel': 'Cancel',
  'coach.createPlan.success': 'Plan created successfully',
  'coach.createPlan.error': 'Error creating plan',
  'coach.createPlan.error.nameRequired': 'Plan name is required',
  'coach.createPlan.error.descriptionRequired': 'Plan description is required',
  'coach.createPlan.error.durationRequired': 'Plan duration is required',
  'coach.createPlan.error.workoutsPerWeekRequired': 'Number of workouts per week is required',
  'coach.createPlan.error.startDateRequired': 'Start date is required',
  'coach.createPlan.error.endDateRequired': 'End date is required',
  'coach.createPlan.error.workoutsRequired': 'You must add at least one workout to the plan',
  'coach.createPlan.error.invalidDates': 'End date must be after start date',
  'coach.createPlan.error.invalidDuration': 'Duration must be greater than 0',
  'coach.createPlan.error.invalidWorkoutsPerWeek': 'Number of workouts per week must be greater than 0',
  'coach.createPlan.error.invalidWorkoutsCount': 'Number of workouts must match the number of workouts per week',
  'coach.createPlan.error.invalidWorkoutName': 'Workout name is required',
  'coach.createPlan.error.invalidWorkoutDescription': 'Workout description is required',
  'coach.createPlan.error.invalidWorkoutExercises': 'You must add at least one exercise to the workout',
  'coach.createPlan.error.invalidExerciseName': 'Exercise name is required',
  'coach.createPlan.error.invalidExerciseSets': 'Number of sets is required',
  'coach.createPlan.error.invalidExerciseReps': 'Number of reps is required',
  'coach.createPlan.error.invalidExerciseWeight': 'Weight is required',
  'coach.createPlan.error.invalidExerciseRest': 'Rest time is required',
  'coach.createPlan.error.invalidExerciseNotes': 'Notes are required',
  'coach.createPlan.error.invalidExerciseRPE': 'RPE is required',
  'coach.createPlan.error.invalidExerciseType': 'Exercise type is required',
  'coach.createPlan.error.invalidExerciseMuscleGroup': 'Muscle group is required',
  'coach.createPlan.error.invalidExerciseEquipment': 'Equipment is required',
  'coach.createPlan.error.invalidExerciseDifficulty': 'Difficulty is required',
  'coach.createPlan.error.invalidExerciseVideo': 'Video is required',
  'coach.createPlan.error.invalidExerciseImage': 'Image is required',
  'coach.createPlan.error.invalidExerciseInstructions': 'Instructions are required',
  'coach.createPlan.error.invalidExerciseTips': 'Tips are required',
  'coach.createPlan.error.invalidExerciseCommonMistakes': 'Common mistakes are required',
  'coach.createPlan.error.invalidExerciseVariations': 'Variations are required',
  'coach.createPlan.error.invalidExerciseProgression': 'Progression is required',
  'coach.createPlan.error.invalidExerciseRegression': 'Regression is required',
  'coach.createPlan.error.invalidExerciseScaling': 'Scaling is required',
  'coach.createPlan.error.invalidExerciseModifications': 'Modifications are required',
  'coach.createPlan.error.invalidExerciseAlternatives': 'Alternatives are required',
  'createPlan.unsavedChanges.message': 'You have unsaved changes. Are you sure you want to leave?',
  'coach.createPlan.buttons.add': 'Add {item}',
  'coach.createPlan.buttons.assign': 'Assign {item}',
  'coach.createPlan.buttons.import': 'Import Exercises',
  'coach.createPlan.buttons.delete': 'Delete',
  'coach.createPlan.buttons.edit': 'Edit',
  'coach.createPlan.buttons.addGroup': 'Add Group',
  'coach.createPlan.buttons.addExercise': 'Add Exercise',
  'coach.createPlan.buttons.addRestPeriod': 'Add Rest Period',
  'coach.createPlan.buttons.addRestPeriod.label': 'Rest Period (seconds)',
  'coach.createPlan.buttons.restPeriod.label': 'Rest Period',
  'coach.delete.confirmation': 'Are you sure you want to delete this workout plan?',
  'coach.delete.header': 'Confirm Delete',
  'coach.delete.error.referenced': 'Error',
  'coach.delete.error.referenced.detail': 'This workout plan is being used by a client',
  'coach.delete.error.generic': 'Error',

  'coach.tabs.workouts': 'Workouts',
  'coach.tabs.plans': 'My Services',
  'coach.tabs.exercises': 'Exercises',
  'coach.tabs.subscription': 'Subscription Plans',
  'coach.tabs.rpe': 'RPE Methods',

  'coach.buttons.add': 'Add {item}',
  'coach.buttons.assign': 'Assign {item}',
  'coach.buttons.import': 'Import Exercises',
  'coach.buttons.import.csv': 'Import from CSV',
  'coach.buttons.assignPlans': 'Assign Workouts',
  'coach.buttons.unassignPlans': 'Unassign Workouts',
  'coach.rpe.name': 'Name',
  'coach.rpe.minValue': 'Minimum Value',
  'coach.rpe.maxValue': 'Maximum Value',
  'coach.rpe.step': 'Step',
  'coach.rpe.valuesMeta': 'Values Meta',
  'coach.rpe.value': 'Value',
  'coach.rpe.color': 'Color (e.g., #FF0000)',
  'coach.rpe.emoji': 'Emoji (e.g., 🔥)',
  'coach.rpe.addValue': 'Add Value',
  'coach.rpe.selectType': 'Select Assignment Type',
  'coach.rpe.create': 'Create RPE Method',
  'coach.rpe.update': 'Update RPE Method',

  'coach.subscription.currentPlan': 'Current Plan',
  'coach.subscription.maxClients': 'Max Clients: {max}',

  'coach.exercise.dragDrop': 'Drag and drop a file here to upload.',
  'coach.exercise.name': 'Exercise Name',
  'coach.exercise.type': 'Type',
  'coach.exercise.description': 'Description',
  'coach.exercise.equipment': 'Equipment Needed',
  'coach.exercise.video': 'Video',
  'coach.exercise.bodyArea': 'Body area involved',
  'coach.exercise.create': 'Create Exercise',
  'coach.exercise.edit': 'Edit Exercise',
  'coach.exercise.error.name.empty': 'Exercise name can not be empty.',
  'coach.exercise.error.video.invalid': 'Please enter a valid YouTube URL',
  'coach.exercise.error.video.invalid.message': 'Please enter a valid YouTube URL',
  'coach.exercise.error.video.invalid.header': 'Error',

  // NewManageStudents
  'students.title': 'Your students',
  'students.subtitle': "View and manage your students' progress",
  'students.description':
    "Use this page to track your students' progress, assign training plans, and communicate with them directly.",

  'students.search': 'Search students',
  'editor.groupType.label': 'Type',
  'editor.groupType.standard': 'Standard',
  'editor.groupType.rest': 'Rest',
  'editor.groupType.superset': 'Superset',
  'editor.groupType.circuit': 'Circuit',
  'editor.groupType.tabata': 'Tabata',
  'editor.groupType.emom': 'EMOM',
  'editor.groupType.amrap': 'AMRAP',
  'editor.groupType.workSeconds': 'Work (s)',
  'editor.groupType.restSeconds': 'Rest (s)',
  'editor.groupType.rounds': 'Rounds',
  'editor.groupType.interval': 'Interval (s)',
  'editor.groupType.totalRounds': 'Total rounds',
  'editor.groupType.totalSeconds': 'Total (s)',
  'students.addNew': 'Add New Student',
  'students.noStudents': 'No students found.',

  'students.table.name': 'Name',
  'students.table.email': 'Email',
  'students.table.status': 'Status',
  'students.table.lastPayment': 'Last Payment',
  'students.table.nextPayment': 'Next Payment',
  'students.table.plan': 'Subscription Plan',
  'students.table.actions': 'Actions',

  'students.status.active': 'Active',
  'students.status.inactive': 'Inactive',

  'students.actions.viewProfile': 'View Profile',
  'students.actions.registerPayment': 'Register Payment',
  'students.actions.deleteSubscription': 'Delete Subscription',
  'students.actions.sendMessage': 'Send Message',
  'students.actions.deleteClient': 'Delete Client',
  'students.actions.resendVerification': 'Resend Verification',
  'students.actions.assignSubscription': 'Assign Subscription',
  'students.actions.editProfile': 'Edit Profile',

  'students.dialog.newStudent': 'New Student',
  'students.dialog.assignSubscription': 'Assign Subscription',
  'students.dialog.registerPayment': 'Register Payment',
  'students.dialog.studentDetails': 'Student Details',
  'students.dialog.editProfile': 'Edit Profile',

  'students.confirm.deleteSubscription': "Are you sure you want to delete this client's subscription?",
  'students.confirm.deleteClient': 'Are you sure you want to delete this client?',
  'students.success.deleted': 'Client successfully deleted!',
  'student.updatedSuccessfully': 'Student updated successfully',
  'students.success.verificationSent': 'Verification email sent successfully!',
  'students.success.updated': 'Profile updated successfully!',
  // NewStudentHome
  'studentHome.welcome': 'Welcome, {name}!',
  'studentHome.streak.daily': 'Daily Streak',
  'studentHome.streak.weekly': 'Weekly Streak',
  'studentHome.streak.days': 'days',
  'studentHome.streak.weeks': 'weeks',
  'studentHome.todayWorkouts': "Today's Workouts",
  'studentHome.noWorkoutsToday': 'No workouts scheduled for today',
  'studentHome.viewWorkout': 'View Details',
  'studentHome.startWorkout': 'Start Workout',
  'studentHome.viewCalendar': 'View Full Calendar',
  'workout.status.pending': 'Pending',
  'workout.status.completed': 'Completed',
  'workout.status.expired': 'Expired',
  'studentHome.dialog.planDetails': 'Plan Details',
  'studentHome.noEvents': 'No training sessions scheduled',
  'studentHome.todayDate': 'Today is {date}',
  'studentHome.upcomingSessions': 'Upcoming sessions',
  'studentHome.loading.calendar': 'Loading your calendar...',
  'studentHome.error.calendar': 'Error loading calendar',
  'studentHome.calendar.title': 'Workout Calendar',
  'studentHome.calendar.filterMonth': 'Filter by month',
  'studentHome.calendar.viewDetails': 'View details',
  'studentHome.calendar.startTraining': 'Start Training',

  // Months (if not existing)
  'months.january': 'January',
  'months.february': 'February',
  'months.march': 'March',
  'months.april': 'April',
  'months.may': 'May',
  'months.june': 'June',
  'months.july': 'July',
  'months.august': 'August',
  'months.september': 'September',
  'months.october': 'October',
  'months.november': 'November',
  'months.december': 'December',

  // Calendar
  'calendar.today': 'Today',
  'calendar.month': 'Month',
  'calendar.week': 'Week',
  'calendar.day': 'Day',
  'calendar.list': 'List',

  // Error messages
  'error.fetchTraining': 'Failed to fetch training data',

  // NewStudentsDetails
  'studentDetails.title': "{name}'s Details",
  'studentDetails.back': 'Back',
  'studentDetails.loading': 'Loading...',

  'studentDetails.personalInfo.title': 'Personal Information',
  'studentDetails.personalInfo.email': 'Email',
  'studentDetails.personalInfo.fitnessGoal': 'Fitness Goal',
  'studentDetails.personalInfo.activityLevel': 'Activity Level',

  'studentDetails.activities.title': 'Recent Activities',
  'studentDetails.progress.title': 'Progress',

  'studentDetails.plans.current': 'Current Training Plans',
  'studentDetails.plans.completed': 'Completed Training Plans',
  'studentDetails.plans.name': 'Plan Name',
  'studentDetails.plans.description': 'Description',
  'studentDetails.plans.notes': 'Notes',
  'studentDetails.plans.startDate': 'Start Date',
  'studentDetails.plans.endDate': 'End Date',
  'studentDetails.plans.status': 'Status',
  'studentDetails.plans.progress': 'Progress',

  'studentDetails.dialog.planDetails': 'Plan Details',
  'studentDetails.dialog.confirmDelete': 'Are you sure you want to delete this plan?',
  'studentDetails.dialog.confirmDeleteHeader': 'Confirm Delete',

  'studentDetails.success.planDeleted': 'You have deleted the plan {name} successfully!',
  'studentDetails.error.fetchData': 'Failed to fetch student data',

  'studentDetails.tooltip.viewDetails': 'View Details',
  'studentDetails.tooltip.deletePlan': 'Delete Plan',

  // NewTrainingDetails
  'training.comments.placeholder': 'Write your comments here...',
  'training.title': 'Training Plan',
  'training.status': 'Status',
  'training.group': 'Group {number}',
  'training.setCount': 'Set Count',
  'training.restInterval': 'Rest Interval',
  'training.seconds': 'seconds',

  'training.exercise.details': 'Exercise Details',
  'training.exercise.progress': 'Exercise Progress',
  'training.exercise.set': 'Set',
  'training.exercise.reps': 'Reps',
  'training.exercise.weight': 'Weight ({unit})',
  'training.exercise.time': 'Time ({unit})',
  'training.exercise.distance': 'Distance ({unit})',
  'training.exercise.tempo': 'Tempo ({unit})',
  'training.exercise.difficulty': 'Difficulty ({unit})',
  'training.exercise.duration': 'Duration ({unit})',
  'training.exercise.completed': 'Completed',
  'training.exercise.sets': 'Sets',
  'training.exercise.comments': 'Comments',

  'training.checkbox.completed': 'Completed',
  'training.checkbox.notAsPlanned': 'Completed Not as Planned',

  'training.buttons.saveProgress': 'Save Progress',
  'training.buttons.exit': 'Leave the training',
  'training.exit.title': 'Leave the training?',
  'training.exit.body':
    'What you marked stays saved on this device and you can pick it up later. But the session is not recorded until you finish it.',
  'training.exit.keepTraining': 'Keep training',
  'training.exit.confirm': 'Leave anyway',
  'training.buttons.finishTraining': 'Finish Training',
  'training.buttons.viewDetails': 'View Details',

  'training.success.saved': 'Progress saved successfully',
  'training.success.finished': 'Congratulations, you have finished your routine.',

  'training.error.noFeedback': 'No feedback to submit',
  'training.error.exerciseNotFound': 'Exercise not found',
  'training.error.fillAllFields': 'Please fill all fields',

  'training.loading': 'Loading...',

  // TrainingDetails
  'training.group.title': 'Group {number}',
  'training.group.set': 'Sets',
  'training.group.rest': 'Rest',

  'training.exercise.video': 'Video URL',

  'training.exercise.rpe': 'RPE',

  'training.plan.name': 'Plan Name',
  'training.plan.status': 'Status',

  'training.buttons.save': 'Save Progress',
  'training.buttons.clearProgress': 'Clear Progress',
  'training.buttons.finish': 'Finish Training',

  'training.error.fillFields': 'All relevant fields must be filled out.',

  // NewCreatePlan
  'plan.create.title': 'Create Plan',
  'plan.edit.title': 'Edit Plan',
  'plan.name': 'Plan Name',
  'plan.notes': 'Personalized Notes',

  'plan.buttons.import': 'Import from Image',
  'plan.buttons.addGroup': 'Add Group',
  'plan.buttons.undoDelete': 'Undo Delete',
  'plan.buttons.clearPlan': 'Clear Plan',
  'plan.buttons.createPlan': 'Create Plan',
  'plan.buttons.editPlan': 'Edit Plan',

  'plan.group.title': 'Group {number}',
  'plan.group.restPeriod': 'Rest Period',
  'plan.group.isRestPeriod': 'Is Rest Period',
  'plan.group.addGroup': 'Add Group',
  'plan.group.addRest': 'Add Rest',
  'plan.group.restDuration': 'Rest Duration (seconds)',
  'plan.group.restDurationRequired': 'Rest duration is required.',
  'plan.group.seconds': 'seconds',
  'plan.group.name': 'Group name',
  'plan.group.set': 'Set',
  'plan.group.rest': 'Rest (seconds)',
  'plan.group.addExercise': 'Add Exercise',
  'plan.group.removed': 'Group Removed',
  'plan.group.removed.message.number': 'The group number {number} has been removed',
  'plan.group.removed.message.name': 'The group "{name}" has been removed',
  'plan.group.empty': 'Drag and drop exercises here to add them to the group.',
  'plan.group.empty.notDraggable': 'No exercises in this group',
  'plan.group.restDurationSuffix': ' seconds',

  'plan.exercise.select': 'Select an Exercise',
  'plan.exercise.add': 'Add Exercise',
  'plan.exercise.notes': 'Notes',
  'plan.exercise.property.add': 'Add Property',

  'plan.dialog.confirmClear': 'Are you sure you want to clear the entire workout plan?',
  'plan.dialog.confirmCreate': 'Are you sure you want to create this plan?',
  'plan.dialog.confirmEdit': 'Are you sure you want to edit this plan?',

  'plan.success.created': 'You have created the plan {name} successfully!',
  'plan.success.updated': 'You have updated the plan {name} successfully!',
  'plan.success.imported': 'The workout plan has been imported from the image successfully.',

  'plan.error.nameRequired': 'Plan name is required.',
  'plan.error.groupRequired': 'At least one group is required.',
  'plan.error.exerciseRequired': 'Each group must have at least one exercise.',
  'plan.error.exerciseSelect': 'Each exercise must be selected. {name} is not selected.',

  // Exercise properties
  'exercise.properties.sets': 'Sets',
  'exercise.properties.reps': 'Repetitions',
  'exercise.properties.time': 'Time',
  'exercise.properties.weight': 'Weight',
  'exercise.properties.restInterval': 'Rest Interval',
  'exercise.properties.tempo': 'Tempo',
  'exercise.properties.difficulty': 'Difficulty',
  'exercise.properties.duration': 'Duration',
  'exercise.properties.distance': 'Distance',
  'exercise.properties.height': 'Height',
  'exercise.properties.restPeriod': 'Rest Period',
  'exercise.properties.notes': 'Notes',
  'exercise.properties.perceivedDifficulty': 'Perceived Difficulty',
  'exercise.properties.mood': 'Mood',
  'exercise.properties.energyLevel': 'Energy Level',
  'exercise.properties.extraNotes': 'Extra Notes',
  'exercise.properties.generalFeedback': 'General Feedback',
  'exercise.properties.realEndDate': 'Real End Date',
  'exercise.properties.sessionTime': 'Session Time',
  'exercise.properties.completed': 'Completed',
  'exercise.properties.notCompleted': 'Not Completed',
  'exercise.properties.completedNotAsPlanned': 'Completed Not as Planned',
  'exercise.properties.comments': 'Comments',
  'exercise.properties.setLogs': 'Set Logs',
  'exercise.properties.restDuration': 'Rest Duration (seconds)',
  // Confirmation messages
  'confirm.delete': 'Are you sure you want to delete this?',
  'confirm.deleteGroup': 'Are you sure you want to delete this group?',
  'confirm.header': 'Confirm Action',

  // Success/Error messages
  'success.saved': 'Successfully saved',
  'success.deleted': 'Successfully deleted',
  'success.updated': 'Successfully updated',
  'error.generic': 'Something went wrong',
  'error.required': 'This field is required',

  // Tooltips
  'tooltip.addExercise': 'Add exercise',
  'tooltip.removeExercise': 'Remove exercise',
  'tooltip.addProperty': 'Add property',
  'tooltip.removeProperty': 'Remove property',
  'tooltip.dragGroup': 'Drag to reorder',

  // Filters and sorting
  'filter.byName': 'Filter by name',
  'filter.byType': 'Filter by type',
  'sort.ascending': 'Ascending',
  'sort.descending': 'Descending',

  // NewTrainingDetails - Additional
  'training.exercise.videoUrl': 'Video URL',

  'training.checkbox.readOnly': 'Read Only',

  'training.session.finished': 'Session finished!',
  'training.session.congrats': 'Congratulations, you have finished your routine!',

  'training.property.repetitions': 'Repetitions',
  'training.property.weight': 'Weight',
  'training.property.time': 'Time',
  'training.property.distance': 'Distance',
  'training.property.tempo': 'Tempo',
  'training.property.difficulty': 'Difficulty',
  'training.property.duration': 'Duration',
  'training.property.restInterval': 'Rest Interval',

  'training.dialog.finishTitle': 'Finish Training',
  'training.dialog.videoTitle': 'Exercise Video',
  'training.markAllCompleted': 'Mark all as completed',
  'training.markAllSkipped': 'Mark all as skipped',
  'training.finish.incomplete': 'Incomplete',
  'training.finish.completeMeasurements': 'Complete the subjective measurement inputs for each set before finishing.',
  'training.confirm.title': 'Did you finish everything?',
  'training.confirm.message': "You haven't marked all exercises. Did you finish everything?",
  'training.confirm.messagePartial':
    "You haven't marked all sets. You can save what you did (unmarked sets will be saved as not completed) or mark everything as finished.",
  'training.confirm.savePartial': 'Save what I did',
  'training.confirm.markAllDone': 'Mark all as finished',
  'training.confirm.goBack': 'Go back and mark what I missed',

  // Coach Dashboard Widgets
  'dashboard.upcomingWorkouts': 'Upcoming Workouts',
  'dashboard.paymentDates': 'Payment Dates',
  'dashboard.runningOut': 'Running Out of Workouts',
  'dashboard.importantDates': 'Important Dates',
  'dashboard.lastTrained': 'Last Trained',
  'dashboard.revenue': 'Revenue',
  'dashboard.alerts': 'Alerts',
  'dashboard.consistency': 'Training Consistency',
  'dashboard.today': 'Today',
  'dashboard.tomorrow': 'Tomorrow',
  'dashboard.yesterday': 'Yesterday',
  'dashboard.session': 'Session',
  'dashboard.daysLeft': 'days',
  'dashboard.sessionsLeftLabel': 'sessions',
  'dashboard.runsOutOn': 'Runs out of workouts on {date}',
  'dashboard.overdue': 'overdue',
  'dashboard.noUpcoming': 'No upcoming workouts',
  'dashboard.noPaymentData': 'No payment data',
  'dashboard.noCycleData': 'No cycle data',
  'dashboard.noImportantDates': 'No important dates',
  'dashboard.noTrainingData': 'No training data',
  'dashboard.noRevenueData': 'No revenue data',
  'dashboard.noFrequencyData': 'No frequency data',
  'dashboard.noAlerts': 'All good, no alerts',
  'dashboard.sessionsLast7Days': 'sessions last 7 days',
  'dashboard.lastMonths': 'last {count} months',

  // NewClientDashboard - Additional
  'dashboard.calendar.viewDetails': 'View Workout Details',
  'dashboard.calendar.assignWorkout': 'Assign Workouts to Day',
  'dashboard.calendar.assignWorkoutTo': 'Assign Workout',
  'dashboard.calendar.pendingStatus': 'Pending',
  'dashboard.calendar.completedStatus': 'Completed',
  'dashboard.calendar.expiredStatus': 'Expired',
  'dashboard.calendar.currentStatus': 'In progress',
  'dashboard.calendar.warningStatus': 'Attention required',
  'dashboard.calendar.addSession': 'Add session',
  'dashboard.calendar.addSessionTooltip': 'Add new workout to this day',
  'dashboard.calendar.moreEvents': '{num} more workouts',
  'clientDashboard.cycle.createNewCycle': 'Create New Cycle',

  'dashboard.table.set': 'Set',
  'dashboard.table.type': 'Type',
  'dashboard.table.expected': 'Expected',
  'dashboard.table.completed': 'Completed',

  'dashboard.exercise.status.completed': '✔',
  'dashboard.exercise.status.notCompleted': '✘',

  'dashboard.dialog.planDetails': 'Plan Details',
  'plan.details.sessionInfo': 'Session information',
  'plan.details.editExercises': 'Edit exercises',

  'dashboard.chart.expectedReps': 'Expected Repetitions',
  'dashboard.chart.completedReps': 'Completed Repetitions',
  'dashboard.chart.averageWeight': 'Average Weight (kg)',
  'dashboard.chart.averageRpe': 'Average RPE',

  'dashboard.calendar.today': 'Today',
  'dashboard.calendar.month': 'Month',
  'dashboard.calendar.week': 'Week',
  'dashboard.calendar.day': 'Day',
  'dashboard.calendar.list': 'List',

  // NewCoachHome - Additional
  'coach.home.trainingFrequencyChart': 'Training Frequency Chart',
  'coach.home.noFrequencyData': 'No frequency data yet',
  'coach.home.clientsSummary': 'Clients Summary',
  'coach.home.table.clientName': 'Client',
  'coach.home.table.lastWorkout': 'Last Workout',
  'coach.home.table.daysLeft': 'Days Left',
  'coach.home.table.paymentStatus': 'Payment Status',
  'coach.home.table.totalSessions': 'Total Sessions',
  'coach.home.table.totalRevenue': 'Total Revenue',
  'coach.home.table.header': 'Other Section',
  'coach.home.table.last30days': 'Last 30 Days',
  'coach.home.table.didPay': 'Did Pay?',
  'coach.home.table.nextPayment': 'Next Payment',
  'coach.home.table.subscriptionStatus': 'Subscription Status',
  'coach.home.extraSectionInfo': 'Additional content or brief summary.',
  'coach.home.activeStudents': 'Active Students',
  'coach.home.totalStudents': 'Total Students',
  'coach.home.paidUp': 'Paid Up',
  'coach.home.averageDaysLeft': 'Avg. Days Left',
  'coach.home.studentsStatus': 'Students Status',
  'coach.home.unpaidClients': 'Unpaid Clients',
  'coach.home.daysLeft': 'Days Left',
  'coach.home.last7daysFrequency': 'Last 7 Days Frequency',
  'coach.home.noDaysLeftData': 'No days left data yet',
  'coach.home.noFrequencyData7days': 'No frequency data for the last 7 days yet',
  'coach.home.noPaidData': 'No paid data yet',
  'coach.home.noUnpaidData': 'No unpaid data yet',
  'coach.home.allPaid': 'All clients have paid their subscriptions',

  'coach.sections.trainingPlans': 'Training Plans',
  'coach.sections.trainingSessions': 'Training Sessions',
  'coach.sections.trainingCycles': 'Training Cycles',
  'coach.sections.recentActivity': 'Recent Activity',
  'coach.sections.recentMessages': 'Recent Messages',
  'coach.sections.workoutProgress': 'Workout Progress',
  'coach.sections.upcomingSessions': 'Upcoming Sessions',

  'coach.trainingCycle.description':
    'Here you can see the training cycles you have and create new ones. You can also assign training sessions to a cycle as well as assign a cycle to a client.',

  'coach.buttons.newPlan': 'New Plan',
  'coach.buttons.editPlan': 'Edit Plan',
  'coach.buttons.openChat': 'Open Chat',
  'coach.buttons.upgradePlan': 'Upgrade Plan',

  'coach.subscription.status': 'Subscription Status',
  'coach.subscription.clientsManaged': 'Clients Managed: {current}/{max}',

  'coach.progress.completed': 'Completed: {count}',
  'coach.progress.pending': 'Pending: {count}',
  'coach.progress.expired': 'Expired: {count}',
  'coach.progress.total': '{completed}/{total} Completed',

  'coach.calendar.noUpcomingSession': 'No upcoming session',

  'coach.chart.completed': 'Completed',
  'coach.chart.pending': 'Pending',
  'coach.chart.expired': 'Expired',

  // ForgotPassword
  'forgotPassword.title': 'Forgot Password',
  'forgotPassword.email': 'Email',
  'forgotPassword.emailPlaceholder': 'Enter your email',
  'forgotPassword.message': 'Enter your email to receive a verification code and reset your password.',
  'forgotPassword.sendCode': 'Send Code',
  'forgotPassword.sendLink': 'Send Reset Link',
  'forgotPassword.codeSent': 'Verification code sent to your email',
  'forgotPassword.codeMessage': 'Please enter the verification code sent to {email}',
  'forgotPassword.verificationSuccess': 'Code verified successfully! Now you can reset your password.',
  'forgotPassword.success': 'Password reset link has been sent to your email.',
  'forgotPassword.error': 'Something went wrong',
  'forgotPassword.error.emailRequired': 'Email is required',
  'forgotPassword.confirm.exit':
    'If you leave now, you will need to request a new verification code. Do you want to exit?',

  // HomePage
  'home.header.features': 'Features',
  'home.header.pricing': 'Pricing',
  'home.header.about': 'About',
  'home.header.contact': 'Contact',
  'home.header.login': 'Login',

  'header.settings': 'Settings',
  'header.logout': 'Logout',
  'header.profile': 'Profile',
  'header.clients': 'Clients',
  'header.workouts': 'Workouts',
  'header.progress': 'Progress',
  'header.home': 'Home',
  'header.plans': 'Plans',
  'home.verification.resend': 'Resend Email Verification',

  'home.hero.subtitle': 'Empower trainers, motivate clients, and achieve fitness goals together.',
  'home.hero.getStarted': 'Get Started',
  'home.hero.learnMore': 'Learn More',
  'home.hero.transformYour': 'Transform Your',
  'home.hero.fitnessJourney': 'Fitness Journey',
  'home.hero.withTrainEase': 'with TrainEase',

  'home.hero.easyToUse': 'Easy to use',
  'home.hero.safeAndReliable': 'Safe and reliable',
  'home.hero.support': '24/7 Support',

  'home.features.title': 'Key Features',
  'home.features.manageClients': 'Manage Clients',
  'home.features.manageClientsDesc': 'Easily manage your clients details and progress in one place.',
  'home.features.customPlans': 'Custom Training Plans',
  'home.features.customPlansDesc': "Create personalized workout routines tailored to each client's needs.",
  'home.features.trackProgress': 'Track Progress',
  'home.features.trackProgressDesc': 'Visualize client progress with data-driven charts and reports.',
  'home.features.videoTutorials': 'Video Tutorials',
  'home.features.videoTutorialsDesc':
    'Access a comprehensive library of exercise videos and create custom workout demonstrations.',

  'home.pricing.title': 'Pricing Plans',
  'home.pricing.maxClients': 'Max Clients',

  'home.footer.contact': 'Contact',
  'home.footer.contactWhatsApp': 'Contact via WhatsApp',

  'home.hero.platform': 'Professional Fitness Platform',
  'home.hero.trustIndicator1': 'Easy to use',
  'home.hero.trustIndicator2': 'Safe and reliable',
  'home.hero.trustIndicator3': '24/7 Support',
  'home.hero.feature1': 'Client management',
  'home.hero.feature2': 'Progress tracking',
  'home.hero.feature3': 'Video tutorials',

  'home.features.subtitle': 'Discover the tools that will transform your way of training and managing clients',
  'home.pricing.subtitle': 'Choose the plan that best fits your needs and start transforming your business',
  'home.pricing.perMonth': 'per month',
  'home.pricing.customPlans': 'Custom plans',
  'home.pricing.progressTracking': 'Progress tracking',
  'home.pricing.support': '24/7 Support',
  'home.footer.description':
    'Transform your fitness business with the most complete platform for professional trainers.',
  'home.footer.copyright': '© 2024 TrainEase. All rights reserved.',

  'home.hero.rating': '5.0 Rating',
  'home.hero.coaches': '1000+ Coaches',
  'home.hero.watchDemo': 'Watch Demo',
  'home.hero.customTrainingPlans': 'Custom Training Plans',
  'home.hero.customTrainingPlansDesc':
    "Create personalized workout routines tailored to each client's needs and goals.",
  'home.hero.trustedBy': 'Trusted by',

  'home.login.title': 'Log In',
  'home.login.email': 'Email',
  'home.login.emailPlaceholder': 'Enter your email',
  'home.login.password': 'Password',
  'home.login.passwordPlaceholder': 'Enter your password',
  'home.login.forgotPassword': 'Forgot your password?',
  'home.login.noAccount': "Don't have an account?",
  'home.login.signUp': 'Sign Up',
  'home.login.validation.emailRequired': 'Email is required',
  'home.login.validation.emailInvalid': 'Enter a valid email address',
  'home.login.validation.passwordRequired': 'Password is required',
  'home.login.error.generic': 'Unable to log in. Please try again.',

  'home.signup.title': 'Sign Up',
  'home.signup.email': 'Email',
  'home.signup.emailPlaceholder': 'Enter your email',
  'home.signup.password': 'Password',
  'home.signup.passwordPlaceholder': 'Create a secure password',
  'home.signup.confirmPassword': 'Confirm Password',
  'home.signup.confirmPasswordPlaceholder': 'Confirm your password',
  'home.signup.haveAccount': 'Already have an account?',
  'home.signup.login': 'Log In',
  'home.signup.validation.emailRequired': 'Email is required',
  'home.signup.validation.emailInvalid': 'Enter a valid email address',
  'home.signup.validation.passwordRequired': 'Password is required',
  'home.signup.validation.confirmPasswordRequired': 'Confirm your password',
  'home.signup.validation.passwordTooShort': 'Password must be at least 6 characters',
  'home.signup.validation.passwordMismatch': 'Passwords do not match',
  'home.signup.success': 'Account created! Check your email to verify it.',
  'home.signup.error.generic': 'Unable to sign up. Please try again.',
  'home.pricing.subscribe': 'Subscribe',

  'home.toast.verifyEmail': 'Verify your email prior to logging in!',
  'home.toast.checkEmail': 'Check your email to continue!',
  'home.toast.error': 'Error',
  'home.toast.success': 'Success',

  'home.error.verifyEmail': 'Please verify your email before signing in!',
  'home.error.checkEmail': 'Check your email to continue!',
  'home.verification.title': 'Email Verification',
  'home.verification.message': 'Please enter the verification code sent to {email}',
  'home.verification.code': 'Verification code',
  'home.verification.verify': 'Verify',
  'home.verification.success': 'Email verified successfully!',
  'home.verification.error': 'Error verifying email',
  'home.verification.error.invalidCode': 'Invalid verification code',
  'home.verification.resendSuccess': 'Verification code sent successfully!',
  'home.verification.resendError': 'Error resending verification code',
  // ResetPassword
  'resetPassword.title': 'Reset Password',
  'resetPassword.message': 'Enter your new password',
  'resetPassword.newPassword': 'New Password',
  'resetPassword.newPasswordPlaceholder': 'Enter your new password',
  'resetPassword.confirmPassword': 'Confirm Password',
  'resetPassword.confirmPasswordPlaceholder': 'Confirm your new password',
  'resetPassword.button': 'Reset Password',
  'resetPassword.success': 'Password reset successfully',
  'resetPassword.error.match': 'Passwords do not match',
  'resetPassword.error.passwordRequired': 'Password is required',
  'resetPassword.error.confirmPasswordRequired': 'Confirm your password',
  'resetPassword.error.passwordTooShort': 'Password must be at least 6 characters',
  'resetPassword.error.generic': 'Something went wrong',
  'resetPassword.confirm.exit': 'If you leave now, your password will not be changed. Do you want to exit?',

  // NotSubscribed
  'notSubscribed.title': 'No active subscription',
  'notSubscribed.message': "You don't have any subscription available. Talk to your coach to fix this.",
  'notSubscribed.button': 'Go to Login',

  // Unauthorized
  'unauthorized.title': 'Unauthorized',
  'unauthorized.message': 'You do not have permission to view this page.',
  'unauthorized.button': 'Go to Login',

  // WorkoutTable
  'workoutTable.trainingDay': 'Training Day: {day}',
  'workoutTable.exercise': 'Exercise',
  'workoutTable.day': '{day} - {plan}',
  'workoutTable.selectCycleDay': 'Select a cycle and day of the week',
  'workoutTable.cycle': 'Cycle',
  'workoutTable.dayOfWeek': 'Day of the week:',
  'workoutTable.selectCycle': 'Select Cycle',
  'workoutTable.selectDay': 'Select Day',
  'workoutTable.monday': 'Monday',
  'workoutTable.tuesday': 'Tuesday',
  'workoutTable.wednesday': 'Wednesday',
  'workoutTable.thursday': 'Thursday',
  'workoutTable.friday': 'Friday',
  'workoutTable.saturday': 'Saturday',
  'workoutTable.sunday': 'Sunday',
  'workoutTable.createNewWorkout': 'Create New Workout',
  'workoutTable.addTraining': 'Add Training',
  'workoutTable.addExercise': 'Add Exercise',
  'workoutTable.selectExercise': 'Select Exercise',
  'workoutTable.selectWeeks': 'Select Weeks',
  'workoutTable.week': 'Week {week}',
  'workoutTable.modifyAll': 'Modify All',
  'workoutTable.addNewExercise': 'Exercise',
  'workoutTable.sets': 'Sets',
  'workoutTable.repetitions': 'Repetitions',
  'workoutTable.weight': 'Weight',
  'workoutTable.time': 'Time',
  'workoutTable.restInterval': 'Rest Interval',
  'workoutTable.tempo': 'Tempo',
  'workoutTable.notes': 'Notes',
  'workoutTable.difficulty': 'Difficulty',
  'workoutTable.duration': 'Duration',
  'workoutTable.distance': 'Distance',
  'workoutTable.newExercise': 'New Exercise',
  'workoutTable.selectGroup': 'Select Group',
  'workoutTable.addNewGroup': 'Add Group',
  'workoutTable.enterTrainingName': 'Enter the name of the training',
  'workoutTable.enterName': 'Enter the name of the training',
  'workoutTable.trainingName': 'Training Name',
  'workoutTable.error.verifyChanges': 'Error verifying changes',
  'workoutTable.error.deleteExercises': 'Error deleting exercises',
  'workoutTable.deleteExercise': 'Delete Exercise',
  'workoutTable.exercisesDeleted': 'Exercises deleted: ',
  'workoutTable.exercisesUpdated': 'Exercises updated: ',
  'workoutTable.selectProperties': 'Select Properties',
  'workoutTable.addProperties': 'Add Properties',
  'workoutTable.missingExerciseIds': 'The following exercises do not have an assigned ID',
  'workoutTable.cannotMoveLastExercise': 'Cannot move the last exercise from a group',
  'workoutTable.groupCannotBeEmpty': 'A group cannot be left without exercises',
  'workoutTable.noGroupsAvailable': 'No groups available',
  'workoutTable.changesSaved': 'Changes saved successfully',
  'workoutTable.exerciseAlreadyExists': 'Exercise already exists on the group',
  'exercise.properties.loading': 'Loading properties...',
  'exercise.selectExercise': 'Select Exercise',

  'students.remainingDays': 'Remaining Days',
  'students.fitnessGoal': 'Fitness Goal',
  'students.status': 'Status',
  'students.status.verified': 'Verified',
  'students.status.unverified': 'Unverified',
  'students.status.unverified.tooltip': 'The email has not been verified',
  'students.resendVerification': 'Resend Email Verification',
  'students.cancelSubscription': 'Cancel Subscription',
  'students.viewProfile': 'View Profile',
  'students.registerPayment': 'Register Payment',
  'students.assignSubscription': 'Assign Subscription',

  'clientDashboard.tabs.dashboard': 'Dashboard',
  'clientDashboard.tabs.workouts': 'Workouts',
  'clientDashboard.tabs.progress': 'Progress',
  'clientDashboard.tabs.settings': 'Settings',
  'clientDashboard.tabs.profile': 'Profile',
  'clientDashboard.tabs.clients': 'Clients',
  'clientDashboard.tabs.payments': 'Payments',
  'clientDashboard.tabs.medicalHistory': 'Medical History',
  'clientDashboard.tabs.userData': 'User Data',
  'clientDashboard.comingSoon.dashboard': 'We are working on a dashboard with statistics and progress metrics.',
  'clientDashboard.comingSoon.medicalHistory': "Soon you will be able to manage your clients' medical history.",
  'clientDashboard.comingSoon.userData': 'Soon you will be able to view and edit all user data from here.',
  'clientDashboard.showExcelOnly': 'Show only Excel view',
  'clientDashboard.showFullDashboard': 'Show full dashboard',

  'coach.rpe.basicInfo': 'Basic Information',
  'coach.rpe.name.tooltip': 'Name of the RPE method',
  'coach.rpe.step.tooltip': 'Increment between values',
  'coach.rpe.minValue.tooltip': 'Minimum value of the range',
  'coach.rpe.maxValue.tooltip': 'Maximum value of the range',
  'coach.rpe.value.tooltip': 'Numeric value',
  'coach.rpe.color.tooltip': 'Color in hexadecimal format (e.g., #FF0000)',
  'coach.rpe.emoji.tooltip': 'Representative emoji',
  'coach.rpe.generateValues': 'Generate Values',
  'coach.rpe.generateValues.tooltip': 'Automatically generate values based on the defined range and step',
  'coach.rpe.error.invalidRange': 'The specified range and step are invalid',
  'coach.rpe.methods': 'RPE Methods',
  'coach.rpe.assignments': 'RPE Assignments',
  'coach.rpe.method': 'RPE Method',
  'coach.rpe.targetType': 'Target Type',
  'coach.rpe.targetName': 'Target Name',
  'coach.rpe.confirm.removeAssignment': 'Are you sure you want to remove this RPE assignment?',

  'common.client': 'Client',
  'common.assignedOn': 'Assigned On',

  // Coach Profile Tabs
  'coach.tabs.clients': 'Clients',

  // Coach Exercise Management
  'coach.addExercise': 'Add Exercise',
  'coach.importExercises': 'Import Exercises',
  'coach.dragAndDropExercises': 'Drag and drop Excel file here',
  'coach.exercises': 'Exercises',
  'coach.exerciseList': 'Exercise List',
  'coach.noExercisesFound': 'No exercises found',
  'coach.missingExercises': 'Exercises Missing Data',
  'coach.missingExercisesWarning': 'The following exercises are missing important data',
  'coach.noMissingExercises': 'No exercises are missing data',
  'coach.exercises.title': 'Exercise Library',
  'exercises.import.duplicatesInFile.title':
    'Duplicate exercise names found in the file. Please fix the Excel file and re-import.',
  'exercises.import.duplicatesInFile.rows': 'rows {rows}',
  'exercises.import.previewVideo': 'Preview video',
  'coach.exercise.title': 'Exercise',

  // Coach Plan Management
  'coach.createPlan': 'Create Plan',
  'coach.plans.title': 'Training Plans',
  'coach.plan.title': 'Plan',
  'coach.noPlans': 'You have no training plans yet',
  'coach.createFirstPlan': 'Create your first plan',
  'coach.createNewPlan': 'Create New Plan',
  'coach.editPlan': 'Edit Plan',
  'coach.plan.name': 'Plan Name',
  'coach.plan.price': 'Price',
  'coach.plan.paymentFrequency': 'Payment Frequency',
  'coach.plan.paymentFrequency.placeholder': 'Select payment frequency',
  'coach.plan.paymentFrequency.monthly': 'Monthly',
  'coach.plan.paymentFrequency.weekly': 'Weekly',
  'coach.plan.paymentFrequency.perSession': 'Per Session',

  // Coach Client Management
  'coach.myClients': 'My Clients',
  'coach.noClientsFound': 'No clients found',
  'client.name': 'Name',
  'client.email': 'Email',
  'client.status': 'Status',
  'client.expiresOn': 'Expires On',
  'client.sendMessage': 'Send Message',
  'client.title': 'Client',
  'common.view': 'View',
  'common.created': 'Created',
  'common.complete': 'Complete',
  'common.createdAt': 'Created At',
  'common.or': 'or',

  // Coach RPE Methods
  'coach.createRpeMethod': 'Create RPE Method',
  'coach.assignRpe': 'Assign RPE',
  'coach.rpeMethods': 'RPE Methods',
  'coach.rpeAssignments': 'RPE Assignments',
  'coach.noRpeMethods': 'You have no RPE methods yet',
  'coach.createFirstRpeMethod': 'Create your first RPE method',
  'coach.noRpeAssignments': 'No RPE assignments found',
  'coach.createNewRpeMethod': 'Create New RPE Method',
  'coach.editRpeMethod': 'Edit RPE Method',
  'rpe.method': 'RPE Method',
  'rpe.targetType': 'Target Type',
  'rpe.targetName': 'Target Name',
  'rpe.step': 'Step',
  'rpe.name': 'Name',
  'rpe.minValue': 'Min Value',
  'rpe.maxValue': 'Max Value',
  'rpe.valuesMeta': 'Value Descriptions',
  'rpe.addValueMeta': 'Add Value Description',
  'rpe.noValuesMeta': 'No value descriptions added yet',
  'rpe.value': 'Value',
  'rpe.description': 'Description',
  'rpe.selectMethod': 'Select RPE Method',
  'rpe.selectTargetType': 'Select Target Type',
  'rpe.selectTarget': 'Select Target',
  'rpe.target': 'Target',
  'coach.rpe.error.missingFields': 'Please select all required fields',
  'coach.rpe.clearValues': 'Clear Values',
  // Coach Subscription
  'coach.subscription.plans': 'Subscription Plans',
  'coach.subscription.details': 'Subscription Details',
  'coach.subscription.includedFeatures': 'All features included',
  'coach.subscription.upgrade': 'Upgrade Plan',
  'coach.subscription.startDate': 'Start Date',
  'coach.subscription.renewalDate': 'Renewal Date',
  'coach.subscription.paymentMethod': 'Payment Method',

  // Exercise
  'exercise.name': 'Name',
  'exercise.type': 'Type',
  'exercise.description': 'Description',
  'exercise.equipment': 'Equipment',
  'exercise.video': 'Video',
  'exercise.searchByName': 'Search by name',
  'exercise.searchByType': 'Search by type',
  'exercise.searchByDescription': 'Search by description',
  'exercise.selectType': 'Select Type',
  'exercise.watchVideo': 'Watch Video',
  'exercise.noVideo': 'No Video Available',
  'exercise.watchYouTube': 'Watch on YouTube',
  'exercise.missingData': 'Missing Data',
  'exercise.title': 'Exercise',
  'exercise.create': 'Create Exercise',
  'exercise.edit': 'Edit Exercise',
  'exercise.chooseVideo': 'Choose Video',
  'exercise.uploadVideo': 'Upload Video',
  'exercise.previewVideo': 'Preview Video',
  'exercise.preview': 'Preview',
  'exercise.videoNotSupported': 'Your browser does not support the video tag',
  'exercise.youtubeUrl': 'YouTube URL',
  'exercise.multimedia': 'Multimedia',
  'exercise.count': 'Count',
  'exercise.equipmentNeeded': 'Equipment Needed',
  'exercise.bodyAreas': 'Body Areas',

  'exercises.globalBadge': 'Library',
  'exercises.globalBadge.tooltip': 'Exercise from the public library (read-only)',
  'exercises.globalBadge.actionsLocked': 'Read-only',
  'rpe.globalBadge': 'Global',
  'rpe.globalBadge.tooltip': 'Global preset method (read-only)',
  'rpe.globalBadge.actionsLocked': 'Read-only',
  'coach.onboarding.title': '👋 Let’s get you started',
  'coach.onboarding.progress': '{done} of {total} steps completed',
  'coach.onboarding.dismiss': 'Don’t show again',
  'coach.onboarding.task.profile': 'Complete your profile',
  'coach.onboarding.task.profile.cta': 'Complete profile',
  'coach.onboarding.task.library': 'Explore the exercise library',
  'coach.onboarding.task.library.cta': 'Open library',
  'coach.onboarding.task.template': 'Create your first session template',
  'coach.onboarding.task.template.cta': 'Create template',
  'coach.onboarding.task.cycle': 'Create your first training cycle',
  'coach.onboarding.task.cycle.cta': 'Create cycle',
  'coach.onboarding.task.client': 'Invite your first client',
  'coach.onboarding.task.client.cta': 'Invite client',
  'coach.onboarding.task.assignPlan': 'Assign a plan to your client',
  'coach.onboarding.task.assignPlan.cta': 'Assign plan',

  // Plan
  'plan.details': 'Plan Details',
  'plans.name': 'Name',
  'plans.description': 'Description',
  'plans.isTemplate': 'Is Template',
  'plans.makeTemplate': 'Make this plan a template',
  'plans.created': 'Created',

  // Validation
  'validation.required': 'This field is required',

  // NewCoachHome - Additional
  'coach.home.welcome': 'Welcome, {name}',
  'coach.home.today': 'Today',
  'coach.home.yesterday': 'Yesterday',
  'coach.home.daysAgo': '{days} days ago',
  'coach.home.sessions': 'sessions',
  'coach.home.quickActions': 'Quick Actions',
  'coach.home.createWorkout': 'Create Workout',
  'coach.home.addExercise': 'Add Exercise',
  'coach.home.viewProfile': 'View My Profile',
  'coach.home.manageStudents': 'Manage Students',
  'coach.home.viewAll': 'View All',
  'coach.home.noClientsData': 'No client data available',
  'coach.home.table.last7days': 'Last 7 Days',
  'common.inactive': 'Inactive',
  'coach.home.newClient': 'New Client',
  'coach.home.newTraining': 'New Training',
  'coach.home.newExercise': 'New Exercise',

  'coach.home.remainingDays': 'Remaining Days',
  'coach.home.trainingFrequency': 'Training Frequency',
  'coach.home.clientList': 'Client List',
  'coach.home.paymentStatus': 'Payment Status',
  'coach.home.lastTraining': 'Last Training',

  'coach.home.manageClient': 'Manage Client',

  'coach.home.noUnpaidClients': 'No unpaid clients',
  'coach.home.noRemainingDays': 'No clients with remaining days',
  'coach.home.noTrainingFrequency': 'No training frequency data',
  'coach.home.noClients': 'No clients found',
  'coach.home.paid': 'Paid',
  'coach.home.unpaid': 'Unpaid',
  'coach.home.pending': 'Pending',
  'coach.home.days': 'days',
  'coach.home.timesPerWeek': 'times per week',
  'coach.home.timesPerMonth': 'times per month',
  'coach.home.timesPerYear': 'times per year',

  'coach.exercise.upload.updated': 'Updated Exercises',
  'exercise.exerciseType': 'Exercise Type',

  // Student Home

  // Student Calendar
  'studentCalendar.title': 'My Training Calendar',
  'studentCalendar.filterMonth': 'Filter by month',
  'studentCalendar.viewDetails': 'View details',
  'studentCalendar.startTraining': 'Start training',
  'studentCalendar.noEvents': 'No events scheduled for this month',
  'studentCalendar.loading': 'Loading calendar...',

  // Assign Workout to Cycle Dialog
  'assignWorkoutToCycleDialog.unassignByDay': 'Unassign by day',
  'assignWorkoutToCycleDialog.deleteEntireCycle': 'Delete entire cycle',
  'assignWorkoutToCycleDialog.selectCycle': 'Select Cycle',
  'assignWorkoutToCycleDialog.selectDay': 'Select Day',
  'assignWorkoutToCycleDialog.selectWorkout': 'Select Workout',
  'assignWorkoutToCycleDialog.assignWorkoutsToCycle': 'Assign Workouts to Cycle',
  'assignWorkoutToCycleDialog.unassignWorkoutsFromCycle': 'Unassign Workouts from Cycle',
  'assignWorkoutToCycleDialog.cycle': 'Cycle',
  'assignWorkoutToCycleDialog.day': 'Day',
  'assignWorkoutToCycleDialog.workout': 'Workout',
  'assignWorkoutToCycleDialog.assign': 'Assign',
  'assignWorkoutToCycleDialog.unassign': 'Unassign',
  'assignWorkoutToCycleDialog.error.assign': 'Error Assigning',
  'assignWorkoutToCycleDialog.error.assign.detail': 'An error occurred while assigning workouts to the cycle.',
  'assignWorkoutToCycleDialog.success.assign': 'Workouts Assigned',
  'assignWorkoutToCycleDialog.success.assign.detail': 'Workouts have been successfully assigned to the cycle.',
  'assignWorkoutToCycleDialog.error.unassign': 'Error Unassigning',
  'assignWorkoutToCycleDialog.error.unassign.detail': 'An error occurred while unassigning workouts from the cycle.',
  'assignWorkoutToCycleDialog.success.unassign': 'Workouts Unassigned',
  'assignWorkoutToCycleDialog.success.unassign.detail': 'Workouts have been successfully unassigned from the cycle.',
  'assignWorkoutToCycleDialog.deleteCycle': 'Delete Cycle',
  'assignWorkoutToCycleDialog.warningTitle': 'Warning',
  'assignWorkoutToCycleDialog.cancel': 'Cancel',
  'assignWorkoutToCycleDialog.confirm': 'Confirm',
  'assignWorkoutToCycleDialog.verificationTitle': 'Deletion Verification',
  'assignWorkoutToCycleDialog.warningMessage':
    'This training cycle has {count} feedback records that will be lost when deleted.',
  'assignWorkoutToCycleDialog.forceDelete': 'Force deletion and lose all records',
  'assignWorkoutToCycleDialog.safeToDelete': 'This cycle can be safely deleted.',
  'assignWorkoutToCycleDialog.assignment': 'Assignment',
  'assignWorkoutToCycleDialog.selectDayOfWeek': 'Select Day of Week',
  'assignWorkoutToCycleDialog.addAssignment': 'Add Assignment',
  'assignWorkoutToCycleDialog.assignWorkouts': 'Assign Workouts',
  'assignWorkoutToCycleDialog.unassignWorkouts': 'Unassign Workouts',
  'assignWorkoutToCycleDialog.success.deleteCycle': 'Cycle Deleted',
  'assignWorkoutToCycleDialog.success.deleteCycle.detail': 'The cycle has been successfully deleted.',
  'assignWorkoutToCycleDialog.error.deleteCycle': 'Error Deleting',
  'assignWorkoutToCycleDialog.error.deleteCycle.detail': 'An error occurred while deleting the cycle.',
  'assignWorkoutToCycleDialog.error.selectWorkoutAndDay':
    'Please select a workout and a day of the week for the last assignment.',
  'assignWorkoutToCycleDialog.error.selectAtLeastOneWorkout': 'Please select at least one workout.',
  'assignWorkoutToCycleDialog.dayOfWeek': 'Day of Week',
  'assignWorkoutToCycleDialog.selectWorkoutToUnassign': 'Select Workout to Unassign',
  'assignWorkoutToCycleDialog.dependenciesTitle': 'Dependent Workouts',

  'verification.codePlaceholder': 'Enter the verification code',
  'verification.code': 'Verification code',
  'verification.verify': 'Verify',
  'verification.success': 'Email verified successfully!',
  'verification.error': 'Error verifying email',
  'verification.error.invalidCode': 'Invalid verification code',
  'verification.error.codeRequired': 'Enter the verification code before continuing',

  // CoachProfileForm
  'coachProfileForm.title': 'Complete Your Coach Profile',
  'coachProfileForm.name': 'Name',
  'coachProfileForm.bio': 'Bio',
  'coachProfileForm.experience': 'Experience',
  'coachProfileForm.trainingType': 'Training focus',
  'coachProfileForm.selectTrainingTypes': 'Select training specialties',
  'coachProfileForm.hasGym': 'I have access to a gym/studio',
  'coachProfileForm.gymLocation': 'Gym location',
  'coachProfileForm.subscriptionType': 'Subscription type',
  'coachProfileForm.freeTrial': 'Free trial · up to 3 clients',
  'coachProfileForm.paid': 'Professional plan',
  'coachProfileForm.choosePlan': 'Choose plan',
  'coachProfileForm.subscriptionPlan': 'Selected plan',
  'coachProfileForm.plan': 'Plan',
  'coachProfileForm.price': 'Price',
  'coachProfileForm.clients': 'clients',
  'coachProfileForm.submit': 'Publish profile',
  'coachProfileForm.summary': 'Profile summary',
  'coachProfileForm.success': 'Profile saved',
  'coachProfileForm.success.message': 'Thanks for subscribing, {name}! Redirecting to your dashboard.',
  'coachProfileForm.error': 'Something went wrong',
  'coachProfileForm.error.noUser': 'Please sign in again to finish your profile.',
  'coachProfileForm.error.missingToken': 'Missing authentication token.',
  'coachProfileForm.error.selectPlan': 'Please pick a subscription plan before continuing.',
  'coachProfileForm.dialog.header': 'Pick a subscription plan',
  'coachProfileForm.step.personalInfo': 'Personal information',
  'coachProfileForm.step.trainingDetails': 'Training details',
  'coachProfileForm.step.subscription': 'Subscription',
  'coachProfileForm.step.confirmation': 'Review & confirm',
  'coachProfileForm.subtitle.personalInfo': 'Tell us a little bit about your experience so clients can recognize you.',
  'coachProfileForm.subtitle.trainingDetails':
    'Select the training styles you specialize in and tell us where you coach.',
  'coachProfileForm.subtitle.subscription': 'Choose how you want to start using TrainEase.',
  'coachProfileForm.subtitle.confirmation': 'Review every detail before launching your profile.',
  'coachProfileForm.helper.training': 'Highlight 2-3 specialties',
  'coachProfileForm.helper.freeTrial': 'Start for free and onboard up to three clients.',
  'coachProfileForm.helper.paid': 'Unlock payments, automation, and advanced analytics.',
  'coachProfileForm.placeholder.pending': 'To be completed',
  'coachProfileForm.placeholder.name': 'e.g., Alex Johnson',
  'coachProfileForm.placeholder.bio': 'Share your coaching philosophy, achievements, or certifications.',
  'coachProfileForm.placeholder.experience': 'Years of experience, primary teams, or notable milestones.',
  'coachProfileForm.placeholder.gymLocation': 'City, neighborhood, or studio name',
  'coachProfileForm.plan.notSelected': 'No plan selected yet',
  'coachProfileForm.plan.cta': 'Select a plan',
  'coachProfileForm.validation.name': 'Name is required.',
  'coachProfileForm.validation.bio': 'Bio is required.',
  'coachProfileForm.validation.experience': 'Experience is required.',
  'coachProfileForm.validation.trainingType': 'Pick at least one training speciality.',
  'coachProfileForm.validation.gymLocation': 'Let us know where your gym is located.',
  'coachProfileForm.validation.subscriptionType': 'Subscription type is required.',
  'coachProfileForm.validation.plan': 'Select a plan to continue.',
  'verification.resend': 'Resend code',
  'verification.title': 'Email Verification',
  'verification.message': 'Please enter the verification code sent to {email}',
  'verification.exitConfirmation':
    "Are you sure you want to leave without verifying your account? You won't be able to sign in until you verify your email.",

  'assignWorkout.error.workoutRequired': 'Choose a workout to assign.',
  'assignWorkout.error.sessionModeRequired': 'Choose the training type.',
  'assignWorkout.title': 'Assign Workout to Session',
  'assignWorkout.description': 'Select a workout to assign to the session',
  'assignWorkout.trainingType': 'Training Type',
  'assignWorkout.selectWorkout': 'Select Workout',
  'assignWorkout.selectWorkoutPlaceholder': 'Select a workout',
  'assignWorkout.selectDate': 'Select Date',
  'assignWorkout.selectDatePlaceholder': 'Select a date',
  'assignWorkout.selectTime': 'Select Time',
  'assignWorkout.selectTimePlaceholder': 'Select a time',
  'assignWorkout.selectRpeMethod': 'Effort Measurement Method',
  'assignWorkout.selectRpeMethodPlaceholder': 'Select RPE method',
  'assignWorkout.rpeMethodInherit': 'Inherit from each exercise',
  'assignWorkout.rpeMethodHelp':
    'If left empty, every exercise uses the method set in its catalog. Useful when you want to mix RPE and RIR in the same session.',
  'assignWorkout.error.rpeRequired': 'Please select an RPE method',
  'assignWorkout.selectLocation': 'Select Location',
  'assignWorkout.selectLocationPlaceholder': 'Select a location',
  'assignWorkout.selectTrainingType': 'Select Training Type',
  'assignWorkout.selectTrainingTypePlaceholder': 'Select a training type',
  'assignWorkout.location': 'Location',
  'assignWorkout.locationPlaceholder': 'Select a location',
  'assignWorkout.sessionTime': 'Session Time',
  'assignWorkout.contactMethod': 'Contact Method',
  'assignWorkout.selectContactMethod': 'Select a contact method',
  'assignWorkout.assign': 'Assign',
  'assignWorkout.createNewSession': 'Create New Session',
  'assignWorkout.meetingLink': 'Meeting Link',
  'assignWorkout.meetingLinkPlaceholder': 'Enter the meeting link',
  'dashboard.calendar.joinMeeting': 'Join Meeting',
  'dashboard.calendar.startTrainingSession': 'Start Training Session',

  'student.trainingType': 'Training Type',
  'student.selectTrainingType': 'Select a training type',
  'student.contactMethod': 'Contact Method',
  'student.selectContactMethod': 'Select a contact method',
  'student.location': 'Location',
  'student.locationPlaceholder': 'Select a location',
  'student.validation.error': 'Please correct the errors in the form before continuing',
  'validation.error': 'Please correct the errors in the form before continuing',
  'student.confirmation.create': 'Are you sure you want to create this student?',
  'student.confirmation.edit': 'Are you sure you want to save the changes?',

  // Mercado Pago
  'payment.method.mercadoPago': 'Mercado Pago',
  'payment.method.bankTransfer': 'Bank Transfer',
  'payment.mercadoPagoDetails': 'Mercado Pago Details',
  'payment.bankTransferDetails': 'Bank Transfer Details',
  'payment.success.bankDataUpdated': 'Bank data updated successfully',
  'error.updatingBankData': 'Error updating bank data',
  'error.fetchingBankData': 'Error fetching bank data',
  'payment.bankData': 'Bank Data',
  'payment.process': 'Process Payment',
  'payment.makePayment': 'Make Payment',
  'payment.method': 'Payment Method',
  'payment.selectMethod': 'Select Payment Method',
  'payment.title': 'Subscription Payment',
  'payment.amount': 'Amount',
  'payment.mercadoPago': 'Mercado Pago',
  'payment.bankTransfer': 'Bank Transfer',
  'payment.accountType.savings': 'Savings Account',
  'payment.accountType.checking': 'Checking Account',
  'payment.mercadoPagoDescription':
    'Make the payment directly through Mercado Pago. You will be redirected to the secure payment page.',
  'payment.bankTransferDescription':
    'Make a bank transfer and notify the coach. The coach will verify the payment and update your subscription.',
  'payment.startDate': 'Start Date',
  'payment.endDate': 'End Date',
  'payment.paymentDate': 'Payment Date',
  'payment.transferDate': 'Transfer Date',
  'payment.selectPlan': 'Select Plan',
  'payment.transferAmount': 'Transfer Amount',
  'payment.transferReference': 'Transfer Reference',
  'payment.enterAmount': 'Enter amount',
  'payment.enterReference': 'Enter reference',
  'payment.payWithMercadoPago': 'Pay with Mercado Pago',
  'payment.notifyTransfer': 'Notify Transfer',
  'payment.redirecting': 'Redirecting to Mercado Pago...',
  'payment.wait': 'Please wait...',
  'payment.coachBankData': 'Coach Bank Data',
  'payment.bankName': 'Bank',
  'payment.accountType': 'Account Type',
  'payment.accountNumber': 'Account Number',
  'payment.cbu': 'CBU',
  'payment.alias': 'Alias',
  'payment.noBankData': 'The coach has not provided bank data.',
  'payment.success.paymentApproved': 'Payment approved successfully',
  'payment.success.paymentRegistered': 'Payment registered and subscription updated successfully',
  'payment.success.transferNotified': 'Transfer notification sent to coach',
  'payment.error.paymentRejected': 'Payment was rejected',
  'payment.error.selectPaymentDate': 'Please select a payment date',
  'payment.error.selectPlan': 'Please select a plan',
  'payment.error.enterTransferReference': 'Please enter a reference for the transfer',
  'payment.error.enterTransferAmount': 'Please enter the transfer amount',
  'payment.error.enterAmount': 'Please enter a valid amount',
  'registerPayment.preview':
    '{periods, plural, one {# period} other {# periods}} will be registered. New end date: {endDate}.',
  'payment.mercadoPagoAccessToken': 'Mercado Pago Access Token',
  'payment.mercadoPagoPublicKey': 'Mercado Pago Public Key',
  'payment.mercadoPagoUserId': 'Mercado Pago User ID',

  'settings.title': 'Settings',
  'settings.general': 'General',
  'settings.notifications': 'Notifications',
  'settings.language': 'Language',
  'settings.theme': 'Theme',
  'settings.logout': 'Logout',
  'settings.darkMode': 'Dark Mode',
  'settings.lightMode': 'Light Mode',
  'settings.system': 'System',
  'settings.language.en': 'English',
  'settings.language.es': 'Spanish',
  'settings.language.pt': 'Portuguese',
  'settings.theme.light': 'Light',
  'settings.theme.dark': 'Dark',
  'settings.theme.system': 'System',
  'settings.unitConfiguration': 'Unit Configuration',

  'createCycle.dialog.header': 'Create Cycle',
  'createCycle.button.create': 'Create',
  'createCycle.useGlobalRpe': 'Use the same RPE method for all sessions',
  'createCycle.globalRpeMethod': 'RPE method for all sessions',
  'createCycle.selectRpeMethod': 'RPE Measurement Method',
  'createCycle.selectRpeMethodPlaceholder': 'Select RPE method',
  'createCycle.error.selectRpeMethod': 'Please select an RPE method',
  'createCycle.clientFacingName': 'Client-facing name',
  'createCycle.clientFacingName.placeholder': 'Leave empty to reuse the cycle name',
  'createCycle.clientFacingName.help': 'If provided, clients will see this name instead of the internal cycle name.',
  'common.optional': 'optional',

  'coach.importExercises.help.title': 'Import exercises from Excel',
  'coach.importExercises.help.intro':
    'Your Excel file can include these columns. Download the template: it comes with filled-in examples and a second sheet listing every value each column accepts.',
  'coach.importExercises.help.downloadTemplate': 'Download template',
  'coach.importExercises.help.chooseFile': 'Choose file',
  'coach.importExercises.help.table.column': 'Column',
  'coach.importExercises.help.table.description': 'Description',
  'coach.importExercises.help.table.required': 'Required',
  'coach.importExercises.help.col.name': 'Exercise name (unique)',
  'coach.importExercises.help.col.description': 'Description or technique',
  'coach.importExercises.help.col.videoUrl': 'Video URL (YouTube)',
  'coach.importExercises.help.col.category_id': 'Category (name or ID)',
  'coach.importExercises.help.col.variant_id': 'Variant (name or ID)',
  'coach.importExercises.help.col.contraction_id': 'Contraction type (name or ID)',
  'coach.importExercises.help.col.difficulty_id': 'Difficulty level (name or ID)',
  'coach.importExercises.help.col.movement_plane_id': 'Movement plane (name or ID)',
  'coach.importExercises.help.col.measurement_method_id': 'Measurement method: RPE 1-10 or RIR 0-5',
  'coach.importExercises.help.col.unilateral_id': 'Unilateral or bilateral (name or ID)',
  'coach.importExercises.help.col.movement_pattern_id': 'Movement pattern (name or ID)',
  'coach.importExercises.help.col.equipment_ids': 'Equipment, comma-separated (name or ID)',
  'coach.importExercises.help.col.muscle_ids': 'Muscles, comma-separated (name or ID)',
  'coach.importExercises.help.col.regression_exercise_id': 'Regression exercise (name or ID)',
  'coach.importExercises.help.col.progression_exercise_id': 'Progression exercise (name or ID)',
  'coach.importExercises.help.header.name': 'Exercise name',
  'coach.importExercises.help.header.videoUrl': 'Video (YouTube)',
  'coach.importExercises.help.header.category_id': 'Category',
  'coach.importExercises.help.header.variant_id': 'Variant',
  'coach.importExercises.help.header.contraction_id': 'Contraction type',
  'coach.importExercises.help.header.difficulty_id': 'Difficulty',
  'coach.importExercises.help.header.movement_plane_id': 'Movement plane',
  'coach.importExercises.help.header.measurement_method_id': 'Measurement method (RPE or RIR)',
  'coach.importExercises.help.header.unilateral_id': 'Unilateral or bilateral',
  'coach.importExercises.help.header.movement_pattern_id': 'Movement pattern',
  'coach.importExercises.help.header.equipment_ids': 'Required equipment',
  'coach.importExercises.help.header.muscle_ids': 'Muscles involved',
  'coach.importExercises.help.header.regression_exercise_id': 'Regression exercise',
  'coach.importExercises.help.header.progression_exercise_id': 'Progression exercise',
  'coach.importExercises.help.sheet.values.id': 'id',
  'coach.importExercises.help.sheet.values.name': 'name',
  'coach.importExercises.help.sheet.values.multi': 'several, comma-separated',
  'coach.importExercises.help.sheet.exercises': 'Exercises',
  'coach.importExercises.help.sheet.values': 'Accepted values',
  'coach.importExercises.help.sheet.values.column': 'Column',
  'coach.importExercises.help.sheet.values.value': 'Accepted value',
  'coach.importExercises.help.templatePartial.title': 'Incomplete template',
  'coach.importExercises.help.templatePartial':
    'We could not load your catalog values. The template was downloaded anyway, but with example names that may not match your database.',
  'coach.importExercises.help.templateError.title': 'Could not generate the template',
  'coach.importExercises.map.title': 'Map your file columns',
  'coach.importExercises.map.intro':
    'We detected these columns in your file. The ones that match are already mapped automatically; review the rest and pick which field each one is. Only the name is required.',
  'coach.importExercises.map.none': '— Don’t import —',
  'coach.importExercises.map.required': 'Map at least one column to the Name field to continue.',
  'coach.importExercises.map.confirm': 'Continue',
  'coach.importExercises.map.detectedColumns': '{n} columns detected',
  'coach.importExercises.map.autoMatched': '{n} mapped automatically',
  'coach.importExercises.map.fileColumn': 'Your file column',
  'coach.importExercises.map.modelField': 'TrainEase field',
  'coach.importExercises.map.noColumns': 'No columns detected in the file. Make sure it has a header row.',
  'exercises.analysis.skippedGlobal':
    "{n} already exist in TrainEase's library and won't be imported (they can't be edited).",
  // Import workout via AI (coach flow)
  'coach.importWorkoutAI.title': 'Import workout with AI',
  'coach.importWorkoutAI.intro':
    'Upload a photo of an Excel or whiteboard, an .xlsx/.csv file, or paste the workout text. The AI detects groups and matches exercises against your catalog.',
  'coach.importWorkoutAI.tab.file': 'File',
  'coach.importWorkoutAI.tab.text': 'Text',
  'coach.importWorkoutAI.dropHint': 'Choose a file to parse',
  'coach.importWorkoutAI.formats': 'JPG · PNG · WebP · XLSX · CSV (max 10 MB)',
  'coach.importWorkoutAI.chooseFile': 'Choose file',
  'coach.importWorkoutAI.changeFile': 'Change file',
  'coach.importWorkoutAI.parseAction': 'Parse with AI',
  'coach.importWorkoutAI.parsing': 'Parsing the workout — this may take a few seconds…',
  'coach.importWorkoutAI.textPlaceholder':
    'Ex: Bench press | Medium | 4x8\\nDeep squat | Light | 8.0\\nSide plank | - | 30 seconds',
  'coach.importWorkoutAI.entryButton': 'Import with AI',
  // Import CYCLE via AI (multi-day batch)
  'coach.importCycleAI.title': 'Import cycle with AI',
  'coach.importCycleAI.intro':
    'Upload an entire planning (photo, .xlsx, .csv, text). The AI detects up to 7 days and matches exercises. After you confirm, a cycle with N workouts is created.',
  'coach.importCycleAI.weeklyWarning':
    'The AI only captures Week 1. Weekly progressions (Week 2/3/4…) must be edited manually afterwards.',
  'coach.importCycleAI.parseAction': 'Parse cycle with AI',
  'coach.importCycleAI.parsing': 'Parsing the planning — this may take several seconds…',
  'coach.importCycleAI.textPlaceholder':
    'Paste the full planning (multi-day). Ex:\\n\\nDay 1 - Pull\\nA1. Pull Ups | 3 | 6 to 8 | 22kg\\nA2. Plank | | 20 to 40" | -\\n\\nDay 2 - Push\\n…',
  'coach.importCycleAI.cycleName': 'Cycle name',
  'coach.importCycleAI.weeks': 'Weeks',
  'coach.importCycleAI.empty': 'No days detected. Cancel and try parsing again.',
  'coach.importCycleAI.createAction': 'Create cycle + {count} workout(s)',
  'coach.importCycleAI.entryButton': 'Import with AI',
  // Quick create exercise (inline + header button)
  'coach.quickCreateExercise.title': 'New exercise',
  'coach.quickCreateExercise.intro':
    'Create a minimal exercise with just the name. You can enrich it later from the exercises library.',
  'coach.quickCreateExercise.name': 'Name',
  'coach.quickCreateExercise.placeholder': 'E.g. Incline dumbbell press',
  'coach.quickCreateExercise.create': 'Create',
  'coach.quickCreateExercise.headerButton': 'Add exercise',
  // Drafts (localStorage, max 3)
  'coach.drafts.saveButton': 'Save draft',
  'coach.drafts.button': 'Drafts ({count}/{max})',
  'coach.drafts.heading': 'Drafts saved locally',
  'coach.drafts.continue': 'Continue this draft',
  'coach.drafts.delete': 'Discard draft',
  'coach.drafts.newBlank': 'New blank workout',
  'coach.drafts.untitled': 'Untitled',
  'coach.drafts.groupsCount': '{count, plural, one {# group} other {# groups}}',
  'coach.drafts.justNow': 'just now',
  'coach.drafts.savedToast': 'Draft saved',
  'coach.drafts.savedDetail': 'You can recover it from "Drafts"',
  'coach.drafts.loadedToast': 'Draft loaded',
  'coach.drafts.deletedToast': 'Draft discarded',
  'coach.exercise.titleSingular': 'Exercise',
  'coach.assign.dialog.header': 'Assign Plans',
  'coach.assign.selectClient': 'Select Client',
  'coach.assign.selectRpeMethod': 'RPE Measurement Method',
  'coach.assign.selectRpeMethodPlaceholder': 'Select RPE method',
  'coach.assign.error.rpeRequired': 'You must select an RPE method',
  'coach.assign.confirm': 'Confirm',
  'coach.assign.error': 'Error',
  'coach.assign.error.detail': 'Please select a client and at least one workout',
  'coach.rpe.assign.title': 'Assign RPE Method',
  'coach.rpe.assign.step1': 'Select type',
  'coach.rpe.assign.step2': 'Select target',
  'coach.rpe.assign.step3': 'Select RPE method',
  'coach.rpe.assign.summary': 'Assignment summary',
  'coach.rpe.assign.target': 'Target',

  // v2 web redesign — design handoff §8
  'setConfig.bulk.copyFirstToAll': 'Copy set 1 to all',
  'setConfig.bulk.progressive': 'Progressive set +2.5kg',
  'setConfig.bulk.reset': 'Reset',
  'setConfig.column.applyToAll': 'Apply to all',
  'setConfig.columns.label': 'Columns',
  'cycle.wizard.step.start': 'Start',
  'cycle.wizard.step.data': 'Details',
  'cycle.wizard.step.assign': 'Assign workouts',
  'cycle.wizard.fromScratch.title': 'From scratch',
  'cycle.wizard.fromScratch.desc': 'Set the duration and which workout goes on each day.',
  'cycle.wizard.fromPreviousCycle.title': 'From a previous cycle',
  'cycle.wizard.fromPreviousCycle.desc':
    'Pick up where you left off: copy a week from a previous cycle of this client, keeping the loads you had been building.',
  'cycle.wizard.fromPreviousCycle.pickCycle': 'Which cycle do we copy from?',
  'cycle.wizard.fromPreviousCycle.pickCyclePlaceholder': 'Choose a previous cycle',
  'cycle.wizard.fromPreviousCycle.pickWeek': 'Which week do we use as the base?',
  'cycle.wizard.fromPreviousCycle.weekSummary': 'Copies {n} training days into every week of the new cycle.',
  'cycle.wizard.fromPreviousCycle.emptyWeek': 'This week has no workouts assigned',
  'cycle.wizard.fromPreviousCycle.empty': 'This client has no previous cycles with workouts yet',
  'cycle.wizard.fromPreviousCycle.success': 'Cycle created from the selected week',
  'cycle.wizard.fromTemplate.title': 'From template',
  'cycle.wizard.fromTemplate.desc': 'Reuse a previously built cycle.',
  'cycle.weekGrid.applyToAllWeeks': 'Apply to all {n} weeks',
  'cycle.weekGrid.dropHere': 'Drop here',
  'cycle.weekGrid.weekN': 'Wk {n}',
  'weekGrid.availableSessions': 'Available sessions',
  'weekGrid.noWorkouts': 'No sessions available',
  'weekGrid.replicateToAll': 'Apply to all {n} weeks',
  'weekGrid.replicateDesc': 'Whatever you set up in week 1 copies to the rest.',
  'weekGrid.week': 'Week',
  'weekGrid.sessionsPerWeek': 'sessions/week',
  'weekGrid.totalSessions': 'total sessions',
  'weekGrid.restDays': 'rest days',
  'calendar.action.programar': 'Schedule',
  'calendar.action.onActiveCycle': 'On active cycle',
  'calendar.action.newCycle': 'New cycle',
  'calendar.action.addSessions': 'Add sessions',
  'calendar.action.removeSessions': 'Remove sessions',
  'calendar.activeCycle.label': 'Active cycle · {name}',
  'session.quickComplete.hint': "Tap an RPE and we'll save the set with the plan.",
  'session.quickComplete.required': 'REQUIRED',
  'session.quickComplete.customize': 'Customize',
  'session.quickComplete.resetPlan': 'Reset to plan',
  'session.skip': 'Skip set',
  'session.rpe.label': 'How hard was it?',
  'session.compare.last': 'Last: {reps}×{weight}kg @ RPE {rpe}',
  'session.compare.target': '+{delta} kg target',
  'excelView.title': 'Excel view',
  'excelView.empty': 'This client has no active cycle',
  'excelView.bulk.autoProgression': 'Auto-progression (+2.5kg/wk)',
  'excelView.bulk.copyColumn': 'Copy column →',
  'excelView.legend.currentWeek': 'Current week',
  'excelView.legend.pr': 'Projected PR',
  'excelView.legend.deload': 'Deload',
  'planEditor.adaptive.extraColumns': '+{n} custom columns',

  // v2 Excel view extras
  'excelView.bulk.duplicateWeek': 'Duplicate week',
  'excelView.bulk.autoProgression.confirm': 'This will add {stepKg} kg each week to every weighted cell. Confirm?',
  'excelView.bulk.copyColumn.confirm': 'Copy values from Week {src} to Week {dst}?',
  'excelView.bulk.duplicateWeek.confirm': 'Duplicate Week {n}? A new week will be inserted right after.',
  'excelView.bulk.duplicateWeek.success': 'Week duplicated.',
  'excelView.bulk.applied': '{n} cells updated.',
  'excelView.bulk.noChanges': 'No changes to apply.',
  'excelView.cell.empty': 'No session planned this week',
  'excelView.cell.sets': '{n} sets',
  'excelView.col.exercise': 'Exercise',
  'excelView.col.sets': 'Sets',
  'excelView.col.copyHint': 'Click to copy to the next week',
  'excelView.selectCycle': 'Select cycle',
  'excelView.noSessions': 'This cycle has no sessions assigned yet.',
  'common.refresh': 'Refresh',
  'common.retry': 'Retry',
  'common.info': 'Info'
};

export default messages;
